import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-consignor-details-box',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './consignor-details-box.component.html',
  styleUrl: './consignor-details-box.component.scss'
})
export class ConsignorDetailsBoxComponent {
  @Input()
  consignorDetails: any;
}
